module.exports = __webpack_public_path__ + "static/lydia-pang-arm-839e8045595b9477d70f5a53f2daaa2c.png";